import { SerializedStyles } from '@emotion/react';
import { JustfiIntegration1 } from '@frontend/api-justifi-integration';
import { useSelectedLocation } from '@frontend/payments-hooks';
import { ContentLoader, useAlert } from '@frontend/design-system';
import { JustifiCard } from './justifi-card';

type JustifiStatusProps = {
  style?: SerializedStyles;
  isActive: boolean;
};
export const JustifiStatus = ({ style, isActive }: JustifiStatusProps) => {
  const alert = useAlert();
  const locationId = useSelectedLocation();

  const { data: subAccountSettingsData, isLoading } = JustfiIntegration1.Queries.useGetSubAccountSettingsQuery({
    request: {
      locationId: locationId ?? '',
    },
    options: {
      enabled: !!locationId,
      onError: (error) => {
        console.error('Error fetching JustiFi sub account settings', error);
        alert.error('Error fetching JustiFi sub account settings');
      },
    },
  });
  const { data: merchantConnectionData } = JustfiIntegration1.Queries.useGetMerchantConnectionQuery({
    request: {
      locationId,
    },
  });

  const businessId = merchantConnectionData?.businessId;

  const { data: businessData } = JustfiIntegration1.Queries.useGetBusinessQuery({
    request: businessId
      ? { locationId: locationId ?? '', businessId }
      : { locationId: locationId ?? '', businessId: '' },
    options: {
      enabled: !!businessId && !!locationId,
    },
  });

  if (!locationId) {
    console.error('JustiFiStatus: locationId is not defined');
    return null;
  }

  return (
    <div css={style}>
      <ContentLoader show={isLoading} />
      <JustifiCard
        isAchPaymentsActive={subAccountSettingsData?.payments?.achPaymentsEnabled}
        isTerminalPaymentsActive={subAccountSettingsData?.payments?.cardPresentEnabled}
        isCardNotPresentPaymentsActive={subAccountSettingsData?.payments?.creditCardPaymentsEnabled}
        createdAt={businessData?.business?.createdAt}
        id={merchantConnectionData?.subAccountId}
        businessName={businessData?.business?.legalName}
        isActive={isActive}
      />
    </div>
  );
};
